<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button [text]="'ZURUECK' | translate"></ion-back-button>
    </ion-buttons>
    <ion-title>{{ 'ERSTINSTRUKTION' | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="padding-16">
    <div class="flex flex-column gap-16">
      @if (project(); as project) {
        <work-ui-badge
          [text]="project?.status?.name || '-'"
          [variant]="project.statusId | getLabelVariantForStatus"
          size="small" />
        <h1>{{ project.numberQualified }}</h1>
      }

      <!-- Dokumente Section -->
      <div class="work-card flex flex-column gap-16">
        <h2>{{ 'DOKUMENTE' | translate }}</h2>
        @for (document of documents(); track document.id) {
          <work-ui-button
            [text]="document.prettyName ?? 'DOKUMENT'"
            [fullWidth]="true"
            iconName="description"
            variant="secondary"
            (buttonClick)="openDocument(document)" />
        }
        @if (documents().length === 0) {
          <p class="color-neutral-600">{{ 'DOKUMENTE_KEINE' | translate }}</p>
        }
      </div>

      <!-- Platzhalter für Instruktionen -->
      <div class="work-card padding-16">
        <h2 class="margin-bottom-12">{{ 'SICHERHEIT' | translate }}</h2>
        <ul class="work-list-bulletpoints margin-bottom-16">
          <li>{{ 'ERSTINSTRUKTION_WEISUNGEN_BEFOLGEN' | translate }}</li>
          <li>{{ 'ERSTINSTRUKTION_ARBEITSFAEHIGER_ZUSTAND' | translate }}</li>
          <li>{{ 'ERSTINSTRUKTION_ALKOHOL_DROGEN_VERBOTEN' | translate }}</li>
        </ul>

        <h2 class="margin-bottom-12">{{ 'PERSOENLICHE_SCHUTZAUSRUESTUNG_PSA' | translate }}</h2>
        <ul class="margin-bottom-16">
          <li>⛑ {{ 'SCHUTZHELM' | translate }}</li>
          <li>👷 {{ 'SICHERHEITSSCHUHE_S3' | translate }}</li>
          <li>🦺 {{ 'ARBEITSKLEIDUNG_OPTIONAL_WARNWESTE' | translate }}</li>
          <li>🧤 {{ 'HANDSCHUHE' | translate }}</li>
          <li>🪜 {{ 'PSAGA_AUFFANGGURT' | translate }}</li>
        </ul>

        <h2 class="margin-bottom-12">{{ 'ARBEITEN_AM_GERUEST' | translate }}</h2>
        <ul class="work-list-bulletpoints margin-bottom-16">
          <li>{{ 'ERSTINSTRUKTION_MONTAGE_GESCHULTES_PERSONAL' | translate }}</li>
          <li>{{ 'ERSTINSTRUKTION_ANLEITUNG_EINHALTEN' | translate }}</li>
          <li>{{ 'ERSTINSTRUKTION_SEITENSCHUTZ_MITFUEHREN' | translate }}</li>
          <li>{{ 'ERSTINSTRUKTION_ABSTURZHOEHE_SICHERN' | translate }}</li>
          <li>{{ 'ERSTINSTRUKTION_PSAGA_ANSCHLAGEN' | translate }}</li>
          <li>{{ 'ERSTINSTRUKTION_OEFFNUNGEN_SICHERN' | translate }}</li>
        </ul>

        <h2 class="margin-bottom-12">{{ 'ORDNUNG_UND_MATERIAL' | translate }}</h2>
        <ul class="work-list-bulletpoints margin-bottom-16">
          <li>{{ 'ERSTINSTRUKTION_ARBEITSPLATZ_SAUBER' | translate }}</li>
          <li>{{ 'ERSTINSTRUKTION_MATERIAL_SICHERN' | translate }}</li>
          <li>{{ 'ERSTINSTRUKTION_DEFEKTES_MATERIAL_MELDEN' | translate }}</li>
        </ul>

        <h2 class="margin-bottom-12">{{ 'UNFAELLE_UND_GEFAHREN' | translate }}</h2>
        <ul class="work-list-bulletpoints margin-bottom-16">
          <li>{{ 'ERSTINSTRUKTION_UNFAELLE_MELDEN' | translate }}</li>
          <li>{{ 'ERSTINSTRUKTION_GEFAHRENSTELLE_SICHERN' | translate }}</li>
          <li>{{ 'ERSTINSTRUKTION_ERSTE_HILFE_KENNEN' | translate }}</li>
        </ul>

        <p class="margin-top-24">
          <strong>{{ 'ERSTINSTRUKTION_BESTAETIGUNG' | translate }}</strong>
        </p>
      </div>

      <!-- Unterschrift Section -->
      <div class="work-card flex flex-column gap-16">
        <div class="flex flex-row space-between vertical-center">
          <h2>{{ 'UNTERSCHRIFT' | translate }}</h2>
          <work-ui-button
            text="LOESCHEN"
            size="small"
            variant="tertiary"
            iconName="delete"
            (buttonClick)="clearSignature()" />
        </div>
        <div class="signature-container">
          <canvas
            #signatureCanvas
            class="signature-canvas"
            (touchstart)="startDrawing($event)"
            (touchmove)="draw($event)"
            (touchend)="stopDrawing()"
            (mousedown)="startDrawing($event)"
            (mousemove)="draw($event)"
            (mouseup)="stopDrawing()"
            (mouseleave)="stopDrawing()">
          </canvas>
        </div>
      </div>

      <!-- Aufgabe abschliessen Button -->
      <work-ui-button
        text="AUFGABE_ABSCHLIESSEN"
        [fullWidth]="true"
        variant="primary"
        [(loadingState)]="uploadLoadingState"
        iconName="check_circle"
        [disabled]="!hasSignature() || isCompleting"
        (buttonClick)="completeTask()" />
    </div>
  </div>

  <!-- Dokumente Viewer Modal -->
  <work-ui-modal modalId="dokumenteViewerModal" #dokumenteViewerModal [noBodyPadding]="true">
    <ng-container modal-body>
      @if (activeDocument(); as activeDocument) {
        <work-ui-dokumente-viewer [activeDocument]="activeDocument" [renderPdfViewer]="!!activeDocument" />
      }
    </ng-container>
  </work-ui-modal>
</ion-content>
